import { createClient } from 'graphql-ws';

import { settings } from 'src/settings';

import { GraphQLWsLink } from './graphql-ws-link';

export const websocketLink = new GraphQLWsLink(
  createClient({
    url: `wss://${window?.location?.host}${
      settings().AGG_WEBSOCKET_SUBSCRIPTIONS_PATH
    }`,
  })
);
